import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import AdminWalletBalance from '../component/AdminWalletBalance';
import actions from '../redux/actions/admin_wallet';

const mapStateToProps = (state) => ({
  ...state.admin_wallets,
});

const mapDispatchToProps = (dispatch) => ({
  addAdminAction: (params, callback) => dispatch(actions.addAdminWalletBalanceAction(params, callback)),
  fetchAllErrERC20Action: (params, callback) => dispatch(actions.fetchAllErrERC20Action(params, callback)),
  fetchAllErrTomoERC20Action: (params, callback) => dispatch(actions.fetchAllErrTomoERC20Action(params, callback)),
  fetchAdminBalancesAction: (params, callback) => dispatch(actions.fetchAdminBalancesAction(params, callback)),
  fetchAdminWalletAction: (params, callback) => dispatch(actions.fetchAdminWalletAction(params, callback)),
  migrateBTCAction: (params, callback) => dispatch(actions.migrateBTCAction(params, callback)),
  migrateETHAction: (params, callback) => dispatch(actions.migrateETHAction(params, callback)),
  migrateERC20Action: (params, callback) => dispatch(actions.migrateERC20Action(params, callback)),
  fixErrERC20Action: (params, callback) => dispatch(actions.fixErrERC20Action(params, callback)),
  fixErrTomoERC20Action: (params, callback) => dispatch(actions.fixErrTomoERC20Action(params, callback)),
  setAdminTransfer: (params, callback) => dispatch(actions.setAdminTransfer(params, callback)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AdminWalletBalance));
